import _ from 'lodash';
import React from 'react';
import autobind from 'autobind-decorator';
import { observer } from 'mobx-react';

@observer
class Pagination extends React.Component {
	render () {
		const { store } = this.props;
		const { pagination: { hasMore, page, pageCount } } = store;

		return (
			<div className="grid-x align-bottom">
				<div className="cell small-12">
					<button
						disabled={ page === 1 }
						onClick={ this.onPrevClick }
						className="button secondary clear"
					>
						<span className="icon fi-arrow-left"></span>
					</button>

					{
						_.range(1, pageCount + 1).map((index) => (
							<button
								key={ index }
								className="button secondary clear"
								data-page-index={ index }
								disabled={ index === page }
								onClick={ this.getOnPageClick(index) }
							>{ index }</button>
						))
					}

					<button
						disabled={ hasMore !== true }
						onClick={ this.onNextClick }
						className="button secondary clear"
					>
						<span className="icon fi-arrow-right"></span>
					</button>
				</div>
			</div>
		);
	}

	@autobind
	getOnPageClick (index) {
		return () => {
			const { store } = this.props;
			store.fetchPagedItems(index);
		};
	}

	@autobind
	onPrevClick () {
		const { store } = this.props;
		const { pagination: { page } } = store;

		if (page === 1) {

			return;
		}

		store.fetchPagedItems(page - 1);
	}

	@autobind
	onNextClick () {
		const { store } = this.props;
		const { pagination: { hasMore, page } } = store;

		if (hasMore !== true) {

			return;
		}

		store.fetchPagedItems(page + 1);
	}
}

export default Pagination;
